// API URL is derived from window.location.origin at runtime
// This works for all environments: dev (via CRA proxy), staging, production
export const API_URL = typeof window !== 'undefined'
  ? window.location.origin
  : 'https://hereabout.app';

export const STREAM_API_KEY = 'z93jj8wh66r4'; // TODO: move to env
